import classnames from '../../node_modules/classnames/index.js';
import { createElement } from 'react';
import styles from '../styles/LoadingDots.module.scss';
import Fade from './Fade.js';
import usePrefersReducedMotion from './usePrefersReducedMotion.js';

/**
 * A loading indicator that can be shown on buttons or if
 * part of the screen is loading. Use LoadingScreen instead
 * for a full screen loading indicator.
 *
 * https://docs.google.com/document/d/1leX_MAwqYNy5PupB7Fiae1JU0VUVBSvsGDoWzrtPuK8/
 */
var LoadingDots = function (_a) {
    var _b;
    var manualPositioning = _a.manualPositioning, type = _a.type;
    var prefersReducedMotion = usePrefersReducedMotion();
    return (
    // TODO: the spec states that the small (button) indicator should not fade.
    createElement(Fade, { animateOnMount: true, duration: 250, isVisible: true },
        createElement("div", { className: classnames(styles["wrap-" + type], (_b = {},
                _b[styles.positioned] = !manualPositioning,
                _b[styles["reduced-motion"]] = prefersReducedMotion,
                _b)) },
            createElement("div", { className: styles.first }),
            createElement("div", { className: styles.second }),
            createElement("div", { className: styles.third }))));
};

export default LoadingDots;
